import { useState, useEffect } from "react";
import axios from "axios";
import Login from "./Login";
import CambiarPassword from "./CambiarPassword";
import AdminPanel from "./AdminPanel";
import SigintPanel from "./SigintPanel";
import IntelProfilePanel from "./IntelProfilePanel";

const API = process.env.REACT_APP_API_URL || "http://localhost:8001/api/v1";

function Header({ usuario, onLogout }) {
  return (
    <div className="bg-gray-900 text-white py-4 px-8 flex justify-between items-center">
      <div className="flex items-center gap-3">
        <img src="/logo.png" alt="ZLinkINT" className="h-8 w-8 object-cover rounded" />
        <div>
          <h1 className="text-2xl font-bold">🛡️ ZlinkINT · OSINT/SIGINT</h1>
          <p className="text-gray-400 text-sm">Plataforma de Inteligencia · Sistema potenciado con IA</p>
        </div>
      </div>
      <div className="flex items-center gap-4">
        <div className="text-right">
          <p className="text-sm font-medium">{usuario.nombre}</p>
          <p className="text-xs text-gray-400">
            Tokens OSINT: <span className="text-green-400 font-bold">{usuario.tokens_osint}</span>
          </p>
        </div>
        
             
        <button
          onClick={() => { window.location.href = process.env.REACT_APP_PORTAL_URL || "http://localhost:9001"; }}
          className="bg-gray-700 hover:bg-gray-600 text-white text-sm px-4 py-2 rounded-lg"
        >
          ← Portal
        </button>
        <button
          onClick={onLogout}
          className="bg-red-700 hover:bg-red-800 text-white text-sm px-4 py-2 rounded-lg"
        >
          Cerrar Sesión
        </button>
      </div>
      
     
    </div>
  );
}

function Dashboard({ usuario, tabInicial, buscarInicial, tipoInicial, aliasInicial, onLogout }) {
  const [tab, setTab] = useState(tabInicial || "intel");

  async function handleLogout() {
    try {
      await axios.post(API + "/auth/logout", {}, { withCredentials: true });
    } catch (e) {}
    window.location.href = process.env.REACT_APP_PORTAL_URL || "http://localhost:9001";
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <Header usuario={usuario} onLogout={handleLogout} />
      <div className="max-w-5xl mx-auto px-4 py-6">
        <div className="flex gap-2 mb-6">
          <button
            onClick={function() { setTab("intel"); }}
            className={"px-4 py-2 rounded-lg font-medium " + (tab === "intel" ? "bg-gray-900 text-white" : "bg-white text-gray-700")}
          >
            🔍 Perfilador
          </button>
          <button
            onClick={function() { setTab("sigint"); }}
            className={"px-4 py-2 rounded-lg font-medium " + (tab === "sigint" ? "bg-gray-900 text-white" : "bg-white text-gray-700")}
          >
            📡 SIGINT
          </button>
          {usuario.es_admin && (
            <button
              onClick={function() { setTab("admin"); }}
              className={"px-4 py-2 rounded-lg font-medium " + (tab === "admin" ? "bg-gray-900 text-white" : "bg-white text-gray-700")}
            >
              ⚙️ Administración
            </button>
          )}
        </div>

        {tab === "intel" && (
          <IntelProfilePanel contextoCDR={null} buscarInicial={buscarInicial} tipoInicial={tipoInicial} aliasInicial={aliasInicial} />
        )}

        {tab === "sigint" && <SigintPanel />}

        {tab === "admin" && usuario.es_admin && (
          <AdminPanel />
        )}

      </div>
    </div>
  );
}

export default function App() {
  const [usuario, setUsuario] = useState(null);
  const [requiereCambio, setRequiereCambio] = useState(false);
  const [tabInicial, setTabInicial]       = useState("intel");
  const [buscarInicial, setBuscarInicial] = useState(null);  // ?buscar=NOMBRE desde CDR/CM
  const [tipoInicial, setTipoInicial]     = useState("telefono");
  const [aliasInicial, setAliasInicial]   = useState(null);  // ?alias=ALIAS desde CM
  const [verificando, setVerificando]     = useState(true);

  // SSO: al cargar, detectar cookie activa emitida por el portal (via /sso redirect)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    // Leer tab destino del URL (?tab=sigint desde el portal)
    const tab = params.get("tab");
    if (tab) setTabInicial(tab);

    // Leer búsqueda pre-cargada desde CDR/CM (?buscar=NOMBRE&tipo=persona&alias=ALIAS)
    const buscar = params.get("buscar");
    const tipo   = params.get("tipo") || "telefono";
    const alias  = params.get("alias");
    if (buscar) {
      setBuscarInicial(decodeURIComponent(buscar));
      setTipoInicial(tipo);
      if (alias) setAliasInicial(decodeURIComponent(alias));
    }

    // Verificar si hay cookie de sesión activa (SSO redirect)
    axios.get(API + "/auth/me", {
      withCredentials: true,
      validateStatus: () => true,
    }).then(res => {
      if (res.status === 200) setUsuario(res.data);
    }).finally(() => setVerificando(false));
  }, []);

  // Heartbeat cada 10s para detectar SLO desde Portal
  useEffect(() => {
    if (!usuario) return;
    const hb = setInterval(() => {
      axios.get(API + "/auth/me", { withCredentials: true, validateStatus: () => true })
        .then(res => {
          if (res.status === 401) handleLogout();
          else if (res.status === 200) setUsuario(res.data); // refresca tokens_osint en pantalla
        });
    }, 10000);
    return () => clearInterval(hb);
  }, [usuario]);

  function handleLogin(usr, cambio, token) {
    setUsuario(usr);
    setRequiereCambio(cambio);
    if (token) {
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    }
  }

  function handleCambio() {
    setRequiereCambio(false);
  }

  function handleLogout() {
    setUsuario(null);
    setRequiereCambio(false);
    window.location.href = process.env.REACT_APP_PORTAL_URL || "http://localhost:9001";
  }

  if (verificando) return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="text-center">
        <div className="text-4xl mb-4">🛡️</div>
        <p className="text-gray-400 text-sm">Verificando sesión…</p>
      </div>
    </div>
  );
  if (!usuario) return <Login onLogin={handleLogin} />;
  if (requiereCambio) return <CambiarPassword onCambio={handleCambio} />;
  return <Dashboard usuario={usuario} tabInicial={tabInicial} buscarInicial={buscarInicial} tipoInicial={tipoInicial} aliasInicial={aliasInicial} onLogout={handleLogout} />;
}